import React from 'react';
import './new_domains.css';

const NewDomainsButton = () => {
  const handleClick = () => {
    const domains = [
      'https://www.xn--950bo4em5v.kr/',
      'https://www.xn--950bo4em5v.net/'
    ];

    const randomDomain = domains[Math.floor(Math.random() * domains.length)];

    window.open(randomDomain, '_blank', 'width=1000,height=780');
  };

  return (
    <a id={'new_domains_btn'} onClick={handleClick}>
      <div className="new_domain_wrapper">
        {/*<div className="named_symbol"></div>*/}
        <div className="new_domains_text">
          <p>주소안내</p>
          <p>즐겨찾기</p>
        </div>
      </div>
    </a>
  );
};

export default NewDomainsButton;